import React, { useEffect, useState } from 'react'
import anchor from "../../images/boat-white.png"
import Title from '../Title'
import { Link } from 'gatsby'
import { useTranslation } from '../../contexts/TranslationContext'

const LINKS = [
    {
        name: "home",
        path: "/"
    },
    {
        name: "aboutUs",
        path: "/about"
    },
    {
        name: "services",
        path: "/services"
    },
    {
        name: "gallery",
        path: "/gallery"
    },
    {
        name: "contact",
        path: "/contact"
    }
];

const CONTACT = [
    {
        name: "+216 25 241 240",
        path: "tel:+21625241240"
    },
    {
        name: "+216 56 133 740",
        path: "tel:+21656133740"
    },
    {
        name: "contact@bescm.com",
        path: "mailto:contact@bescm.com"
    },
    // {
    //     name: "Services",
    //     path: "/services"
    // }
];

const p: any = {
    en: "Ensuring trusted cargo inspections worldwide. Precision, reliability, and peace of mind with every shipment.",
    fr: "Garantir des inspections de cargaison de confiance dans le monde entier. Précision, fiabilité et tranquillité d'esprit pour chaque expédition."
}

export default function Footer() {
    const { t, lang } = useTranslation();

    const currentYear = new Date().getFullYear();

    return (
        <section className='bg-primary text-white py-12 px-4 sm:py-[88px] space-y-[112px] border-t-8 border-primary sm:border-none'>
            <div className='mx-auto max-w-6xl w-full'>
                <div className='grid grid-cols-1 sm:grid-cols-4 gap-4'>
                    <article className='space-y-5'>
                        <div className="flex flex-col gap-1 justify-center">
                            <div><img src={anchor} className="w-[64px] h-[64px]" /> </div>
                            <div className="text-xl font-black">BECSM</div>
                        </div>
                        <div className='text-gray-300'>
                            {p[lang]}
                        </div>

                    </article>
                    <article className='space-y-5 sm:justify-self-center'>
                        <Title customClassName='border-b border-white w-fit'>{t("links")}</Title>
                        <div className='flex flex-col gap-4 text-white'>
                            {LINKS.map((item => <Link to={`/${lang}${item.path}`} className='cap-first'>
                                {t(item.name)}
                            </Link>))}
                        </div>
                    </article>
                    <article className='space-y-5 sm:justify-self-center'>
                        <Title customClassName='border-b border-white w-fit'>{t("contact")}</Title>
                        <div className='flex flex-col gap-4 text-white'>
                            {CONTACT.map((item => <Link to={`${item.path}`}>
                                {item.name}
                            </Link>))}
                        </div>
                    </article>
                    <article className='space-y-5 sm:justify-self-end'>
                        <Title customClassName='border-b border-white w-fit'>{t('officeOpeningHours')}</Title>
                        <div className='flex flex-col gap-4 text-white'>
                            <div>08:00 - 18:00</div>
                            <div>6 / 7</div>
                        </div>
                    </article>
                </div>
            </div>
            <div className='text-gray-300 flex justify-center items-center capitalize'>
                © {currentYear} BECSM. {t("allRightsReserved")}.
            </div>
        </section>
    )
}
